export default "/assets/zoom_brand_logo-1a6cd17ba4a157dd381f581d78438399d33bdfc48761861981cc949bf0f1e8fe.png";